import Vue from "vue";
import App from "./App.vue";
import { createRouter } from "./router";
import { createProvider } from "./vue-apollo";
import plugin from "./plugin";
import VueWait from "vue-wait";
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(VueWait);
Vue.config.productionTip = false;
const wait = new VueWait();

plugin(Vue);
export async function createApp({ beforeApp = () => {}, afterApp = () => {} } = {}) {
  const router = createRouter();

  const apolloProvider = createProvider({
    ssr: process.server,
  });

  await beforeApp({
    router,

    apolloProvider,
  });

  const app = new Vue({
    created() {
      AOS.init({ disable: "phone" });
      window.addEventListener(
        "scroll",
        function() {
          AOS.refresh();
        },
        true
      );
    },
    router,
    apolloProvider,
    render: h => h(App),
    wait,
  });

  const result = {
    app,
    router,

    apolloProvider,
  };

  await afterApp(result);

  return result;
}
